import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const Remove: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M1.66675 9.99996C1.66675 5.39996 5.40008 1.66663 10.0001 1.66663C14.6001 1.66663 18.3334 5.39996 18.3334 9.99996C18.3334 14.6 14.6001 18.3333 10.0001 18.3333C5.40008 18.3333 1.66675 14.6 1.66675 9.99996ZM6.66677 10.8333H13.3334C13.7918 10.8333 14.1668 10.4583 14.1668 9.99997C14.1668 9.54164 13.7918 9.16664 13.3334 9.16664H6.66677C6.20844 9.16664 5.83344 9.54164 5.83344 9.99997C5.83344 10.4583 6.20844 10.8333 6.66677 10.8333Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default Remove;